export default "__VITE_ASSET__5349b89a__"